import { PageType } from 'api/page-template/types';
import { useGetSectionPreviewQuery } from 'queries/templates/queries';
import React from 'react';
import { SectionPreview } from 'components/common';
import { useEmailPreviewStreaming } from './hooks/use-email-preview-streaming';

interface EmailPreviewProps {
  emailThreadId: number;
  emailSubject: string;
  payload: object;
  onBack?: () => void;
  streaming?: boolean;
}

export const EmailPreview: React.FC<EmailPreviewProps> = ({
  emailThreadId,
  emailSubject,
  payload,
  onBack,
  streaming = true,
}) => {
  const { data: previewData, isLoading } = useGetSectionPreviewQuery({
    meetingId: emailThreadId,
    pageType: PageType.Email,
    enabled: true,
    streaming,
    payload: payload,
  });

  const { isInitializingStream, onInitialization } = useEmailPreviewStreaming({
    streaming,
    token: previewData?.streamingMeta?.token,
    channelName: previewData?.streamingMeta?.channelName,
  });

  return (
    <SectionPreview
      title={emailSubject}
      isLoading={isLoading}
      isInitializingStream={isInitializingStream}
      streaming={streaming}
      content={previewData?.finalContent}
      onBack={onBack}
      onInitialization={onInitialization}
    />
  );
};
